import ScrollTo from '../classes/ScrollTo';

class GoTosModule {
    constructor() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.$gotos = document.querySelectorAll('.js-goto');
    }

    bindEvents() {
        [].forEach.call(this.ui.$gotos, ($goto, index) => {
            $goto.addEventListener('click', this.onClickGoto.bind(this));
        });
    }

    onClickGoto(e) {
        e.preventDefault();

        const currentTarget = e.currentTarget,
            targetHref = currentTarget.getAttribute('data-target'),
            $targetEl = document.getElementById(`${targetHref}`);

        new ScrollTo($targetEl, {
            dist: 0
        })
    }
}

export default GoTosModule;
